export default {
  jp: {
    entryStatus: {
      1: '審査中',
      2: '承認済み',
      3: '却下'
    }
  },
  en: {
    entryStatus: {
      1: 'Under review',
      2: 'Approved',
      3: 'Rejection'
    }
  }
}
